import BackButton from "./BackButton";
import NextButton from "./NextButton";
import { useAtom } from "jotai";
import { isMapShownAtom } from "../../jotai-store/isMapShow";
import { useSelector } from "react-redux";

const ORDER = [
  "uploadimages",
  "visionItems",
  "locations",
  "vehicle",
  "schedule",
  "PersonalInfo",
  "ContactInfo",
  "Summary",
];

const NavigationWithEstimate = ({
  tripStatus = "",
  handleUpdateBookingObject,
  isBackButtonDisabled = false,
  handleNextClickValidations,
  setIsBottomSheetOpen,
  isNextButtonDisabled = false,
  onClickHandleSuggestedVehicleAndLabour,
  onClickHandleSaveImagesToBackend,
  onClickHandleBookingCreate,
  estimatePricing,
  estimatePricingLoad,

  // New prop: when a user registers they set this to true so PersonalInfo remains visible
  justRegisteredFromPersonalInfo = false,
  // Setter to clear the flag once user moves past PersonalInfo
  setJustRegisteredFromPersonalInfo,
}) => {
  const { loginInfo } = useSelector((state) => state.loginReducer);
  // Treat user as "logged in" for skipping PersonalInfo only when they were already logged in
  // (i.e., not when they were just registered from the PersonalInfo flow)
  const isLoggedIn = Boolean(loginInfo && loginInfo.id) && !justRegisteredFromPersonalInfo;




  const idx = ORDER.indexOf(tripStatus);
  const [isMapShown, setIsMapShown] = useAtom(isMapShownAtom);


  const getPrev = () => {
    if (idx <= 0) return "";
    const prev = ORDER[idx - 1];
    // If previous step is PersonalInfo but user is logged in, skip it
    if (prev === "PersonalInfo" && isLoggedIn) {
      // skip PersonalInfo and go one step further back
      return ORDER[idx - 2] || "";
    }
    return prev;
  };

  const getNext = () => {
    if (idx === -1) return ORDER[0];
    if (idx >= ORDER.length - 1) return ORDER[ORDER.length - 1];
    const next = ORDER[idx + 1];
    // If next step is PersonalInfo and user is logged in, skip to ContactInfo
    if (next === "PersonalInfo" && isLoggedIn) {
      // skip the PersonalInfo step and jump to the following step
      return ORDER[idx + 2] || ORDER[ORDER.length - 1];
    }
    return next;
  };

  const prev = getPrev();
  const next = getNext();

  // ------------ FIXED BACK BUTTON ------------
  const handleBackClick = () => {
    // back press par map kabhi show nahi hoga

    if (tripStatus === "locations") {
      setIsMapShown(true);
      return;
    } else {
      setIsMapShown(false);
    }

    if (tripStatus === "uploadimages") return;
    handleUpdateBookingObject("tripStatus", prev, `BackTo ${prev}`);
  };
  // -------------------------------------------

  const hideEstimate = (
    [
      "uploadimages",
      "locations",
      "visionItems",
      "PersonalInfo",
      "Summary",
    ].includes(tripStatus)
  );




  return tripStatus !== "Summary" && (
    <div className="w-full flex flex-col h-[111.55px] font-instrument px-[33px] pb-[13.62px] max-w-container">
      {!hideEstimate ? <div className="w-full h-[1px] bg-[#7876A1]" /> : null}

      <div

        className="h-[50.93px] flex items-center justify-between"
      >
        {!hideEstimate ? (
          <>
            <div
              onClick={() => setIsBottomSheetOpen(true)}
              className="text-[14px] font-semibold text-[#211F59] cursor-pointer">
                {estimatePricingLoad ? "Estimating cost" : "Estimated cost:"}
       
            </div>

            <div
              onClick={() => setIsBottomSheetOpen(true)}
              className="flex items-center gap-2 cursor-pointer">
              <span className="text-[20px] text-[#211F59] font-bold">
                {estimatePricingLoad ? (
                  <span className="flex items-center gap-1">
                    {/* <span className="text-[#332A88] text-[16px] font-medium">
                      Estimating
                    </span> */}
                    <span className="dot-loader">
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </span>
                ) : (
                  `$${estimatePricing?.totalCharge || "00.00"}`
                )}
              </span>




              <img
                src="/Vision Agent Icons/Chevron/ChevronLightPurpleUp.svg"
                alt="arrow"
                width={11.17}
                height={5.37}
              />
            </div>
          </>
        ) : (
          <div></div>
        )}
      </div>

      {/* BOTTOM BUTTON AREA */}
      <div className="flex items-center gap-x-[9.5px]">
        {tripStatus !== "" &&
          tripStatus !== "uploadimages" && (
            <>
              <div className="flex-shrink-0">
                <BackButton isDisabled={isBackButtonDisabled} onClick={handleBackClick} />
              </div>

              <div className="flex-1">
                <NextButton
                  isDisabled={isNextButtonDisabled}
                  text="Next"
                  onClick={async () => {
                    const isOk = await handleNextClickValidations();
                    if (!isOk) return;



                    if (next === "vehicle" && onClickHandleSuggestedVehicleAndLabour) {
                      await onClickHandleSuggestedVehicleAndLabour();
                    }
                    if (next === "locations" && onClickHandleSaveImagesToBackend) {
                      const isSuccess = await onClickHandleSaveImagesToBackend();
                      console.log("isSuccess from onClickHandleSaveImagesToBackend:", isSuccess);
                      if (!isSuccess) {
                        return;
                      }
                    }

                    if (next === "Summary" && onClickHandleBookingCreate) {
                      const isSuccess = await onClickHandleBookingCreate();
                      if (!isSuccess) {
                        return;
                      }
                    }

                    // If user was just registered and is currently on PersonalInfo,
                    // clear the flag once they move past it so PersonalInfo is hidden thereafter.
                    if (tripStatus === "PersonalInfo" && setJustRegisteredFromPersonalInfo) {
                      try {
                        setJustRegisteredFromPersonalInfo(false);
                      } catch (e) {
                        // ignore
                      }
                    }

                    // ------ MAIN FIX END ------


                    handleUpdateBookingObject(
                      "tripStatus",
                      next,
                      `NextTo ${next}`
                    );
                  }}
                />
              </div>
            </>
          )}
      </div>
    </div>
  )

};

export default NavigationWithEstimate;
